import PageHeader from "../../../../components/PagesComponents/UniversalComponents/PageHeader.component";
import Title from "../../../../components/Universal/Title.component";
import InfoButton from "../../../../components/Universal/InfoButton.component";
import AddNewPosition from "../../../../components/PagesComponents/Setting/Profile/PositionSetup/AddNewPosition.component";
import SalarySlabs from "../../../../components/PagesComponents/Setting/Profile/PositionSetup/SalarySlabs.component";
import { Helmet } from "react-helmet";

const Body = ({
  handelUpdatePositionList,
  addNewPosition,
  setAddPosition,
  addNewSalarySlab,
  setAddNewSalarySlab,

  salarySlabData,
  handelEditSalarySlab,
  handelAddNewSalarySlab,
  roleData,
}) => {
  return (
    <div className="w-full flex-col align-left justify-start g-1 h-full  overflow-hide">
      <Helmet>
        <title>Setup-Position</title>
      </Helmet>
      <PageHeader title={"Position set with salary slab"} />
      <div className="overflow-hide w-full flex-1 h-full flex-row align-left justify-start g-1">
        <div
          className="flex-col h-full align-left justify-start p-1 radius-10 back-white  g-2 scroll-y"
          style={{ width: "16rem" }}
        >
          <div className="w-full flex-col align-left justify-start g-1">
            <Title>Create positions</Title>
            <hr color="#e5e5e5" className="w-full" />
          </div>
          <div className="flex-col align-left justify-start g-2 flex-1 w-full">
            <div className="flex-row align-center justify-start g-05 w-full">
              <Title>Designations list</Title>
              <InfoButton description={"View designation list"} />
            </div>

            <div className="flex-col align-left justify-start w-full g-1">
              <ol className="flex-col align-left justify-start w-full g-05 ml-1">
                {roleData?.map((data) => {
                  return (
                    <li className="w-full poppins t-13">
                      <div className="flex-row align-center justify-between w-full pl-1 pr-2 g-05">
                        <span
                          className="poppins t-13 color-textColor"
                          style={{ width: "80%" }}
                        >
                          {data?.role}
                        </span>
                        <span
                          style={{
                            width: "1rem",
                            height: "1rem",
                            borderRadius: "50%",
                            background: data.color,
                          }}
                        ></span>
                      </div>
                    </li>
                  );
                })}
              </ol>
              <hr color="#e5e5e5" className="w-full" />
            </div>
            {(addNewPosition || roleData?.length === 0) && (
              <AddNewPosition outputData={handelUpdatePositionList} />
            )}
            {!addNewPosition && (
              <button
                type="button"
                className="actionBtn w-full"
                onClick={() => setAddPosition(!addNewPosition)}
              >
                Add
              </button>
            )}
          </div>
        </div>
        <SalarySlabs
          addNewSalarySlab={addNewSalarySlab}
          setAddNewSalarySlab={setAddNewSalarySlab}
          handelAddNewSalarySlab={handelAddNewSalarySlab}
          handelEditSalarySlab={handelEditSalarySlab}
          salarySlabData={salarySlabData}
        />
      </div>
    </div>
  );
};

export default Body;
